import type { DBRecord } from '../services/PreferencesDB.ts';
import { ICON_EMPTY } from '../services/Directus.ts';
import type { Score } from './Score.ts';

export class Category implements DBRecord {
  id: string = crypto.randomUUID();
  createdAt: number = Date.now();
  lastModified: number = Date.now();
  name: string = 'New Category';
  icon: string = ICON_EMPTY;
  dailyGoal: number = 1;
  taskIds: string[] = [];
  sharedTaskIds: string[] = [];
  scores: Score[] = [];

  getScore(dayOffset: number = 0): number {
    const startOfDay = new Date();
    startOfDay.setHours(0, 0, 0, 0);
    const startTime = startOfDay.getTime() + dayOffset * 24 * 60 * 60 * 1000;
    const endTime = startTime + 24 * 60 * 60 * 1000;
    return this.scores
      .filter((e) => e.createdAt >= startTime && e.createdAt < endTime)
      .reduce((sum, score) => sum + score.value, 0);
  }
  getScores(dayOffset: number = 0): Score[] {
    const startOfDay = new Date();
    startOfDay.setHours(0, 0, 0, 0);
    const startTime = startOfDay.getTime() + dayOffset * 24 * 60 * 60 * 1000;
    const endTime = startTime + 24 * 60 * 60 * 1000;
    return this.scores.filter((e) => e.createdAt >= startTime && e.createdAt < endTime);
  }
}
